/* eslint-disable react-hooks/exhaustive-deps */

import { Form } from "@renderbus/ui";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useForm from "antd/es/form/hooks/useForm";
import { ModalStyle, RechargeForm } from "./atom";
import { Input, Modal, ModalType } from "task-eva-ui";
import { initVerifyRechargeInfo, useFoxTopUpStore } from "../../store";
import { useToastStore } from "@/store/toast-store";

export function RechargeVoucher() {
  const { t } = useTranslation("topup");
  const m1 = t("coupon_rule_first");
  const m2 = t("fox_coupon_code_rule_tips");
  const { setter: setFoxTopUpStore } = useFoxTopUpStore();
  const inputCode = useFoxTopUpStore((state) => state.inputCode);
  const verifyRechargeCode = useFoxTopUpStore(
    (state) => state.verifyRechargeCode
  );
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const { showGlobalToast } = useToastStore();
  const showCouponCodeModal = useFoxTopUpStore(
    (state) => state.showCouponCodeModal
  );
  const amount = useFoxTopUpStore((state) => state.amount);

  const onInput = (val: any) => {
    setFoxTopUpStore({ inputCode: val });
    form.setFieldValue("inputCode", val);
  };

  const verifyCode = () => {
    setLoading(true);
    form
      .validateFields()
      .then(async () => {
        const couponNO = form.getFieldValue("inputCode");
        const { code, data } = await verifyRechargeCode({
          couponNO,
          amount: Number(amount),
        });
        setLoading(false);
        if (code === 200) {
          setFoxTopUpStore({
            verifyRechargeInfo: data,
          });
          showGlobalToast({
            type: "success",
            content: t("fox_coupon_code_tips_200"),
          });
        } else {
          setFoxTopUpStore({
            verifyRechargeInfo: initVerifyRechargeInfo,
          });
          showGlobalToast({
            type: "error",
            content: t(`fox_coupon_code_tips_${code}`),
          });
        }
        form.resetFields(["inputCode"]);
        setFoxTopUpStore({ showCouponCodeModal: false, inputCode: "" });
      })
      .catch((e) => {
        setLoading(false);
      });
  };
  const handleClose = () => {
    form.resetFields(["inputCode"]);
    setFoxTopUpStore({ showCouponCodeModal: false, inputCode: "" });
  };

  useEffect(() => {
    if (showCouponCodeModal) {
      form.setFieldValue("inputCode", inputCode || "");
    }
  }, [showCouponCodeModal, inputCode, form]);

  return (
    <div>
      <Modal
        type={ModalType.Confirm}
        open={showCouponCodeModal}
        title={t("fox_redeem_coupon")}
        submitting={loading}
        onClose={handleClose}
        onOk={verifyCode}
        confirmText={t("fox_coupon_code_add")}
        children={
          <RechargeForm form={form}>
            <div>{t("coupon_recharge_label")}</div>
            <Form.Item
              name="inputCode"
              rules={[
                { required: true, message: m1 },
                {
                  pattern: new RegExp(/^[0-9a-zA-Z]{4,18}$/, "g"),
                  message: m2,
                },
              ]}
            >
              <div className="fox-coupon-code-input">
                <Input
                  value={inputCode}
                  background="#212327"
                  onInput={(e) => onInput?.(e.currentTarget.value)}
                  placeholder={t("fox_coupon_code_btn")}
                />
              </div>
            </Form.Item>
          </RechargeForm>
        }
      />
      <ModalStyle />
    </div>
  );
}
